import * as React from "react";
import i18n from "../../i18n/i18n";
import * as PropTypes from "prop-types";
import * as classNames from "classnames";
import IErrorVm from "../../models/home/Error/IErrorVm";

interface ICheckboxProps {
  readonly?: boolean;
  checked: boolean;
  label: string;
  className?: string;
  errorProperty?: string;
  uiTestAttribute?: string;
  onChange?: (value: boolean) => void;
  hideLabel?: string;
  setBackgroundColorOnError?: boolean;
  hideMargin?: boolean;
}

export default class Checkbox extends React.Component<ICheckboxProps> {
  public context: { errors: IErrorVm[] };

  public static defaultProps: Partial<ICheckboxProps> = {
    readonly: false,
  };

  public static contextTypes: React.ValidationMap<any> = {
    errors: PropTypes.array,
  };

  public render() {
    const { readonly, checked = false, label, onChange, className, errorProperty, uiTestAttribute, setBackgroundColorOnError = false, hideMargin = false } = this.props;

    const errors = (this.context.errors || []).filter((x: IErrorVm) => {
      return !readonly && x.property === errorProperty;
    });

    const labelClasses = classNames({
      required: errorProperty && !readonly,
      checkbox: true,
      inline: true,
    });

    const divClasses = classNames({
      datafield: true,
      "datafield-checkbox": true,
      "checkbox-alert": setBackgroundColorOnError && errors.length > 0,
      className,
    });

    return (
      <div className={divClasses} style={{ margin: hideMargin ? "0px" : "" }}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <input id={label} type="checkbox" checked={checked} data-ui-test={uiTestAttribute || ""} onChange={(e: any) => onChange(e.target.checked)} disabled={readonly} />
              </td>
              <td>
                <label className={labelClasses} htmlFor={label} dangerouslySetInnerHTML={{ __html: i18n.t(label) }}></label>
              </td>
            </tr>
            {!setBackgroundColorOnError && (
              <tr>
                <td colSpan={2}>
                  {errors.map((err, i) => {
                    return (
                      <p key={i} className="alert alert-warning">
                        {err.message}
                      </p>
                    );
                  })}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}
